// Media imports
import neudaTraining from "./images/citi/neuda_training/neudraTraining.mp4";
import ganImg from "./images/machineLearning/gan.JPG";
import vaeImg from "./images/machineLearning/vae.JPG";
import brainImg from "./images/machineLearning/brain.JPG";
import treesImg from "./images/machineLearning/trees.JPG";
import marsImg from "./images/mars/websitecollage.jpg";
import foodHackImg from "./images/foodHackathon/foodhack.jpg";
import airQualityImg from "./images/embedded/collage.JPG";
import synthImg from "./images/embedded/synth.jpg";
import nexusImg from "./images/nexus/nexuscollage.jpg";
import citicollage from "./images/citi/citicollage.jpg";
import infocol from "./images/info/infocol.jpg";
import naudaNetMigration from "./video.mp4";
import tutorTap from "./images/tutortap/tutortap.png";

// -------------------- Projects Data --------------------
export const projectsData = [

  {
  id: 22,
  title: "Real-Time Stocks Trader and News Dashboard",
  mediaType: "video",
  mediaSrc: neudaTraining,
  description: `
Developed a real-time stock trading platform with live news integration using React for the frontend and Java (SpringBoot) for the backend. Implemented WebSocket connections for real-time data updates and integrated third-party APIs for stock prices and news feeds. Designed a user-friendly dashboard to monitor stock performance and execute trades efficiently.`,
  category: "Full Stack",
  techCategory: ["Java", "React", "WebSockets", "APIs"],
  flexBasis: "50%",
},
    {
  id: 21,
  title: "IoT Pollution Monitor",
  description: `
Made a low-latency multi-user data platform on Raspberry Pi using Python multithreading, multiprocessing, mutexes, and GIL-aware processing for concurrent sensor ingestion, local state management, and frontend updates. Implemented websocket streaming to AWS (EC2/DynamoDB), designed DynamoDB schemas, built weight-calculation pipelines, and performed analytics dashboards with pandas/matplotlib.
  `,
  category: "IoT",
  techCategory: ["Python", "AWS", "Raspberry Pi", "WebSockets", "DynamoDB"],
  flexBasis: "50%",
},

  {
    id: 0,
    title: "Tutortap Tuition",
    description: `
Created a website in Angular and deployed on AWS using Lambda and DynamoDB. This project allowed multi-user management and dynamic content generation. Built and deployed the system end-to-end, focusing on backend API design, AWS integration, and optimising low-latency data access.
    `,
    mediaType: "image",
    mediaSrc: tutorTap,
    category: "Full Stack",
    techCategory: ["Angular", "Node.js", "AWS", "DynamoDB", "Lambda"],
    flexBasis: "40%",
  },
  {
    id: 1,
    title: "Neuda Net Migration",
    description: `
This project drew insights from large datasets to explore whether Net Migration is a suitable indicator for the development of a country and the benefits to Citi Bank. Four indicators were explored: Inflation, Life Expectancy, GDP Per Capita and Unemployment. The data was cleaned and analysed using Pandas and visualised using Tableau.
    `,
    mediaType: "video",
    mediaSrc: naudaNetMigration,
    category: "Full Stack",
    techCategory: ["Java", "Angular", "SpringBoot"],
    flexBasis: "50%",
  },
  {
    id: 2,
    title: "This Portfolio",
    description: `
This project was made in React from scratch as part of my portfolio deliverable for 3rd Year and can be viewed on a phone as well!
    `,
    category: "Full Stack",
    techCategory: ["React"],
    flexBasis: "35%",
  },
  {
    id: 3,
    title: "Microsoft Group Consultancy Project Nexus",
    description: `
Nexus combines different Microsoft 365 applications and provides a single point of entry for users to access.
- Dashboard displays the user's calendar, emails, and todos.
- Calendar presents events and provides summaries for missed online meetings.
- Overview serves as a centralised resource hub, enabling users to access and interact with their emails, Teams, and calendar.
- Application tracker uses AI to read company emails and render them on a dashboard with filtering methods.
- SmartScribe summarises text using Azure OpenAI and writes the generated summary to OneNote.
- A universal search bar uses Graph API to search across Microsoft's suite of applications.
    `,
    mediaType: "image",
    mediaSrc: nexusImg,
    category: "Full Stack",
    techCategory: ["React", "Azure"],
    flexBasis: "55%",
  },
  {
    id: 4,
    title: "Wireframe for Correcting Balances New Screen",
    description: `
This wireframe extended the functionality of the portal by connecting the current and new ledger operations by adding 4 new workflows, of which one is a failsafe.
- New Balance Move Request: guides users with validation and simulation steps.
- In Progress Page: provides checkpoints and statuses (In Progress, Successful, Failed, Approved, Rejected).
- Pending Requests for Approval: allows a separate checker to approve/reject.
- View History: shows all activity on the page with dynamic table structures.
    `,
    mediaType: "image",
    mediaSrc: citicollage,
    category: "Full Stack",
    techCategory: ["UX Design"],
    flexBasis: "50%",
  },
  {
    id: 5,
    title: "The Maze Game",
    description: `
This project was part of the Information Processing Module. A multiplayer game where players connected via DE10-Lite FPGAs, and scores were sent to an AWS EC2 instance in real time.
    `,
    mediaType: "image",
    mediaSrc: infocol,
    category: "Full Stack",
    techCategory: ["React", "Node.js", "AWS", "Python"],
    flexBasis: "35%",
  },
  {
    id: 6,
    title: "Autonomous Mars Rover",
    description: `
This project involved creating a Mars Rover to investigate terrain and map alien buildings. I developed the full stack website (React, Node.js, HTML, CSS, JS) for rover tracking and controls. I also designed the rover’s obstacle avoidance algorithm in C++.
    `,
    mediaType: "image",
    mediaSrc: marsImg,
    category: "Full Stack",
    techCategory: ["React", "Node.js", "C++"],
    flexBasis: "60%",
  },
  {
    id: 7,
    title: "Food Poverty Hackathon",
    description: `
As part of a hackathon, we built a platform connecting food banks and beneficiaries. I designed the React + Node.js website allowing food banks to post available food and schools/beneficiaries to request supplies.
    `,
    mediaType: "image",
    mediaSrc: foodHackImg,
    category: "Full Stack",
    techCategory: ["React", "Node.js"],
    flexBasis: "35%",
  },

  // ---------- ML Projects ----------
  {
    id: 8,
    title: "Generative Adversarial Network",
    description: `
Created a GAN using PyTorch. Achieved 85% accuracy on CIFAR-10 image generation with data augmentation and architectural variations. Implemented training pipelines and experimented with batch norm placement for stability.
    `,
    mediaType: "image",
    mediaSrc: ganImg,
    category: "ML",
    techCategory: ["Python", "PyTorch"],
    flexBasis: "55%",
  },
  {
    id: 9,
    title: "Variational AutoEncoder",
    description: `
Created a VAE using PyTorch. Applied architectural modifications, Bayesian hyperparameter optimisation and regularisation. Achieved 90% accuracy by tuning hyperparameters and training on MNIST.
    `,
    mediaType: "image",
    mediaSrc: vaeImg,
    category: "ML",
    techCategory: ["Python", "PyTorch"],
    flexBasis: "40%",
  },
  {
    id: 10,
    title: "Brain Tumour Detection (U-NET)",
    description: `
Developed a neural network for image segmentation to identify brain tumours. Built a 7-layer U-NET in PyTorch, optimised across 10k epochs, achieving 0.045 entropy loss.
    `,
    mediaType: "image",
    mediaSrc: brainImg,
    category: "ML",
    techCategory: ["Python", "PyTorch"],
    flexBasis: "60%",
  },
  {
    id: 11,
    title: "Decision Tree",
    description: `
Implemented a decision tree algorithm for indoor location detection using WiFi signal strengths. Used k-fold cross validation, entropy, and information gain functions to evaluate models.
    `,
    mediaType: "image",
    mediaSrc: treesImg,
    category: "ML",
    techCategory: ["Python"],
    flexBasis: "35%",
  },
  {
    id: 12,
    title: "Neural Networks",
    description: `
Built a mini NN library in PyTorch and a model predicting California house prices with 9 inputs. Implemented forward/backward propagation functions and a regressor class with RMSE metric.
    `,
    category: "ML",
    techCategory: ["Python", "PyTorch"],
    flexBasis: "30%",
  },
  {
    id: 13,
    title: "Self-Supervised Learning (SimCLR)",
    description: `
Trained a network using SimCLR loss and tested on PneumoniaMNIST dataset. Implemented custom augmentations and contrastive loss in PyTorch Lightning. Achieved 0.89 ROC-AUC.
    `,
    category: "ML",
    techCategory: ["Python", "PyTorch"],
    flexBasis: "35%",
  },
  {
    id: 14,
    title: "Spiking Neural Network",
    description: `
Implemented a spiking neural network to reproduce cortical network results based on “Stable propagation of synchronous spiking in cortical neural networks” (Deismann et al.).
    `,
    category: "ML",
    techCategory: ["Python"],
    flexBasis: "30%",
  },

  // ---------- IoT / Embedded ----------
  {
    id: 15,
    title: "Air Quality Tracker",
    description: `
IoT project using Raspberry Pi Zero WH to track CO₂ levels. Built the full-stack website with Google Maps API and Recharts, enabling multiple devices to connect dynamically and visualise data in real time.
    `,
    mediaType: "image",
    mediaSrc: airQualityImg,
    category: "IoT",
    techCategory: ["React", "Python"],
    flexBasis: "40%",
  },
  {
    id: 16,
    title: "Music Synthesiser (ESP32)",
    description: `
A 4-person group project to program an ESP32 music synthesiser in C++. I developed knob controls, multiple waveforms (sawtooth, square, triangle, sine), and linked synthesisers for extended range.
    `,
    mediaType: "image",
    mediaSrc: synthImg,
    category: "IoT",
    techCategory: ["C++", "Embedded"],
    flexBasis: "30%",
  },
  // {
  //   id: 17,
  //   title: "LTSpice Music Synthesiser",
  //   ...
  // },

  // ---------- Other ----------
  {
    id: 17,
    title: "Smart Contract",
    description: `
Created a Solidity smart contract with primary and secondary market bidding. Developed and tested the bidding logic through simulations.
    `,
    category: "Other",
    techCategory: ["Solidity"],
    flexBasis: "35%",
  },
  {
    id: 18,
    title: "C90 to MIPS Compiler",
    description: `
Worked in pairs to build a C90 compiler with flex/bison in C/C++. Implemented AST tree, core language features (if/while/for/function calls), and wrote test scripts.
    `,
    category: "Other",
    techCategory: ["C", "C++"],
    flexBasis: "30%",
  },
  {
    id: 19,
    title: "MIPS CPU",
    description: `
Created a fully synthesisable CPU in SystemVerilog following MIPS ISA. Helped with control/datapath components and wrote test cases.
    `,
    category: "Other",
    techCategory: ["SystemVerilog"],
    flexBasis: "30%",
  },
  {
    id: 20,
    title: "Issie Smart Port Ordering",
    description: `
Issie is used for circuit design. We built smart features to avoid crossed/misaligned wires. I implemented Smart Port Ordering, mapping edges between components and ensuring crossings were resolved by splitting/ordering ports.
    `,
    category: "Other",
    techCategory: ["F#"],
    flexBasis: "35%",
  },
];
